const INDEX_ITEMS = [
  { id: 1, title: '动作大片合集', count: '328部', desc: '热血激战，肾上腺素飙升的视觉盛宴', color: 'from-red-600/80 to-orange-600/80' },
  { id: 2, title: '喜剧电影专场', count: '256部', desc: '爆笑不断，欢乐时刻从这里开始', color: 'from-amber-500/80 to-yellow-500/80' },
  { id: 3, title: '悬疑烧脑推荐', count: '192部', desc: '层层反转，挑战你的推理极限', color: 'from-teal-600/80 to-cyan-600/80' },
  { id: 4, title: '科幻巨制', count: '175部', desc: '超越想象，探索未来世界的无限可能', color: 'from-indigo-600/80 to-purple-600/80' },
  { id: 5, title: '爱情经典', count: '289部', desc: '浪漫动人，关于爱的千百种模样', color: 'from-pink-500/80 to-rose-500/80' },
  { id: 6, title: '恐怖惊悚', count: '143部', desc: '心跳加速，胆量挑战的极致体验', color: 'from-gray-700/80 to-gray-900/80' },
  { id: 7, title: '动画精选', count: '210部', desc: '童趣无限，老少皆宜的动画世界', color: 'from-green-500/80 to-emerald-500/80' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">专题合集</h2>
          <p className="text-sm text-foreground-500 mt-2">按类型精准分类，快速找到你爱看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <div
              key={item.id}
              className={`relative bg-gradient-to-br ${item.color} rounded-xl p-4 md:p-5 text-background-50 overflow-hidden cursor-pointer group h-32 md:h-40 flex flex-col justify-end`}
            >
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
              <div className="relative z-10">
                <div className="text-[10px] font-medium opacity-80 mb-1">{item.count}</div>
                <h3 className="text-sm md:text-base font-bold">{item.title}</h3>
                <p className="text-[10px] md:text-xs opacity-80 mt-1 hidden sm:block line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}